import React from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import ParameterNavigation from 'components/ParameterNavigation';

import CorporateAccounts from '../components/corporateAccounts/CorporateAccounts';
import { AccountCategory } from '../models';

const accountCategories = [AccountCategory.Group];

const Accounts = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeAccountCategory =
    searchParams.get('type') ?? AccountCategory.Group;

  const changeAccountCategory = (index: number) => {
    setSearchParams((prev) => {
      prev.set('type', accountCategories[index]);

      return prev;
    });
  };

  return (
    <Container>
      <ParameterNavigation
        withOffset
        parameters={accountCategories}
        setNewParameter={changeAccountCategory}
        activeParameter={activeAccountCategory}
      />
      {activeAccountCategory === AccountCategory.Group && <CorporateAccounts />}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  max-width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.lightYellow};
  margin: 0 20px 60px;
  box-sizing: border-box;
`;

export default Accounts;
